import React, { useState, useEffect } from "react";
import Button from "../../components/ui/Button";
import { useNavigate } from "react-router-dom";
import { Mail, Smartphone, SquarePen, Trash2, Flag } from "lucide-react";
import goal from "../../assets/images/Coin-Wallet.png";
import Trophy from "../../assets/images/Percentage.png";

import { userApi } from "../../api/user";

export default function UserCard({
  id,
  name,
  role,
  email,
  phone,
  walletBalance,
  commission,
  isActive,
  isFlagged,
  showWin,
  canFlag,
  onToggleStatus,
  onToggleShowWin,
  onToggleFlagged,
}) {
  const navigate = useNavigate();
  const [localShowWin, setLocalShowWin] = useState(showWin);

  const handleShowWinChange = (e) => {
    const newValue = e.target.checked;
    setLocalShowWin(newValue);
    onToggleShowWin(id, newValue);
  };

  return (
    <>
      <div className="flex items-start gap-2.5 border p-2.5 mt-2.5 rounded-md">
        <div className="flex-1">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <h3 className="font-bold text-xl">{name}</h3>

              <span
                className={`text-[10px] text-white font-normal px-2 py-0.5 ml-1 rounded-[20px] ${
                  role.startsWith("General Coordinator")
                    ? "bg-[#FD6C23]"
                    : role.startsWith("Coordinator")
                    ? "bg-[#7051EB]"
                    : "bg-[#EF3E3E]"
                }`}
              >
                {role}
              </span>
            </div>

            {/* toggle button start */}
            <div className="flex items-center gap-2">
              {canFlag && (
                <button
                  onClick={() => onToggleFlagged(!isFlagged)}
                  className={`flex items-center gap-1 rounded-full px-2.5 h-6 text-[10px] font-normal transition-colors duration-300 ${
                    isFlagged
                      ? "bg-red-600 text-white"
                      : "bg-gray-100 text-gray-500 border border-gray-300"
                  }`}
                >
                  <Flag className="w-3 h-3" />
                  {isFlagged ? "Flagged" : "Flag"}
                </button>
              )}
              <button
                onClick={() => onToggleStatus(id, !isActive)} // Pass new status to parent
                className={`flex items-center justify-between rounded-full px-1 w-20 h-6  ${
                  isActive
                    ? "bg-[#1AC057]"
                    : "bg-gray-300 transition-colors duration-300"
                }`}
              >
                {isActive ? (
                  <>
                    <span
                      className={`text-[10px] font-normal ps-2 text-white translate-x-0 transition-transform duration-300 `}
                    >
                      Active
                    </span>
                    <div
                      className={`w-4 h-4 rounded-full bg-white shadow-md transform transition-transform `}
                    ></div>
                  </>
                ) : (
                  <>
                    <div
                      className={`w-4 h-4 rounded-full bg-white shadow-md transform transition-transform `}
                    ></div>
                    <span
                      className={`text-[10px] font-normal pe-2 text-gray-800 translate-x-0`}
                    >
                      Inactive
                    </span>
                  </>
                )}
              </button>
            </div>
            {/* toggle button end */}
          </div>
          <div className="flex items-center gap-2 mt-2">
            <Mail className="w-3.5 h-3.5" />
            <span className="text-xs text-[#12131A]  font-normal">
              {" "}
              {email}{" "}
            </span>
          </div>
          <div className="flex items-center gap-2 mt-2">
            <Smartphone className="w-3.5 h-3.5" />{" "}
            <span className="text-xs text-[#12131A]  font-normal">
              {" "}
              {phone}
            </span>
          </div>

          <div className="grid grid-cols-2 gap-4 mt-4">
            <div
              className=" rounded-lg  flex justify-between"
              style={{
                background: "linear-gradient(180deg, #FFB900 0%, #D92000 100%)",
              }}
            >
              <div className="text-white p-2.5 self-center">
                <div className="text-xs font-normal">Wallet Balance</div>
                <div className="font-semibold text-xl ">₱{walletBalance}</div>
              </div>
              <div className="self-end">
                <img src={goal} alt="Total Hits" width={62} height={62} />
              </div>
            </div>
            <div
              className=" rounded-lg  flex justify-between"
              style={{
                background: "linear-gradient(180deg, #9B00FF 0%, #7D00CE 100%)",
              }}
            >
              <div className="text-white p-2.5 self-center">
                <div className="text-xs font-normal">Commission</div>
                <div className="font-bold text-xl">₱{commission}</div>
              </div>
              <div className="self-end relative">
                <img src={Trophy} alt="Total Win" width={62} height={62} />
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center mt-3">
            <label htmlFor={`toggle-${id}`} className="relative cursor-pointer">
              <input 
                type="checkbox" 
                id={`toggle-${id}`} 
                className="sr-only peer" 
                checked={localShowWin}
                onChange={handleShowWinChange}
              />
              <div className="w-10 h-5 bg-[#292A41] rounded-full peer-checked:bg-[#0E64D1]" />
              <div className="absolute left-1 top-0.5 w-4 h-4 bg-white rounded-full transition-transform peer-checked:translate-x-4" />
            </label>
            <span className="ml-3 text-xs font-normal text-gray-900">
              Show Win Amount
            </span>
          </div>

          <div className="flex text-xs font-normal mt-2.5 gap-2.5">
            <button
              className="flex-1 bg-[#0E64D1] text-white text-xs rounded-[4px]  flex justify-center items-center gap-2 py-2.5"
              onClick={() => navigate(`/modify-user/${id}`)}
            >
              <SquarePen width={14} height={14} />
              Modify
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
